import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

const GET_TEAM_DEFAULT_TEMPLATES = gql`
  query GetTeamDefaultTemplates($teamUuid: String!) {
    team(uuid: $teamUuid) {
      uuid
      defaultTemplates {
        uuid
        name
        templateType
        description
        isFavourite
        sharingType
        teamDefaults
        createdAt
        updatedAt
        user {
          uuid
          firstName
          lastName
          teams {
            organization {
              uuid
            }
            uuid
            name
          }
        }
      }
      organization {
        uuid
      }
    }
  }
`;

export const useTeamDefaultTemplates = (teamUuid: string | null) => {
  const { data, loading, error, refetch } = useQuery(
    GET_TEAM_DEFAULT_TEMPLATES,
    {
      variables: { teamUuid },
      skip: !teamUuid,
    },
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const typedData = data as any;
  return {
    defaultTemplates: typedData?.team?.defaultTemplates || [],
    orgUuid: typedData?.team?.organization?.uuid || null,
    loading,
    error,
    refetch,
  };
};
